var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-wrapper"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"overlay"},[_c('pulse-loader',{staticClass:"loader",attrs:{"loading":_vm.loading}})],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }